module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.isApp && _vm.row.show_status == 2) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('van-empty', {
    attrs: {
      "description": "课程仅在啦啦操GOAPP可浏览"
    }
  }), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.onDownload()
      }
    }
  }, [_vm._v("下载啦啦操GO APP")])], 1) : _vm._e(), _vm._v(" "), (_vm.isApp && !_vm.row.id_cert && _vm.row.show_status == 2) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('van-empty', {
    attrs: {
      "description": "您还未实名认证，请认证后浏览课程资源"
    }
  }), _vm._v(" "), _c('van-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'MyInfo'
      }),
      expression: "{ name: 'MyInfo' }"
    }],
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    }
  }, [_vm._v("立即实名认证")])], 1) : _vm._e(), _vm._v(" "), (_vm.isApp && !_vm.row.danwei_cert && _vm.row.show_status == 2) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('van-empty', {
    attrs: {
      "description": "您还未进行单位认证，请认证后浏览课程资源"
    }
  }), _vm._v(" "), _c('van-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'MyInfo'
      }),
      expression: "{ name: 'MyInfo' }"
    }],
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    }
  }, [_vm._v("立即单位认证")])], 1) : _vm._e(), _vm._v(" "), ((_vm.isApp && _vm.row.id_cert && _vm.row.danwei_cert) || _vm.row.show_status == 1) ? _c('div', {
    staticClass: "box"
  }, [_c('div', [(!_vm.paly_show) ? _c('img', {
    staticClass: "course—pic",
    attrs: {
      "src": _vm.row.pic_url,
      "alt": ""
    }
  }) : _c('video', {
    ref: "videos",
    attrs: {
      "width": "100%",
      "controls": ""
    }
  }, [_c('source', {
    attrs: {
      "id": "playVideosss",
      "src": _vm.play_url
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "course-detail"
  }, [_c('div', {
    staticClass: "course-title-box"
  }, [_c('div', {
    staticClass: "course-detail-title"
  }, [_vm._v(_vm._s(_vm.row.title))]), _vm._v(" "), (_vm.row.need_pay == '1') ? _c('div', {
    staticClass: "course-detail-info"
  }, [_vm._v("免费")]) : _c('div', {
    staticClass: "course-detail-info"
  }, [_c('span', {
    staticClass: "course-price"
  }, [_vm._v("¥" + _vm._s(_vm.row.price))]), _vm._v(" "), _c('span', {
    staticClass: "course-validity"
  }, [_vm._v("有效期 " + _vm._s(_vm.row.pay_days) + "天")])]), _vm._v(" "), _c('div', {
    staticClass: "course-play"
  }, [_c('span', {
    staticClass: "course-num"
  }, [_vm._v("视频 " + _vm._s(_vm.row.items.length))]), _vm._v(" "), _c('span', {
    staticClass: "course-play-num"
  }, [_vm._v("播放" + _vm._s(_vm.row.views_count))])])]), _vm._v(" "), _c('div', {
    staticClass: "course-content"
  }, [_c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.row.content)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "directory"
  }, [_c('van-steps', {
    attrs: {
      "direction": "vertical",
      "active": _vm.videoActive,
      "active-icon": "checked",
      "inactive-icon": "circle"
    }
  }, _vm._l((_vm.row.items), function(item, i) {
    return _c('van-step', {
      key: i
    }, [_c('p', {
      staticClass: "course-title",
      on: {
        "click": function($event) {
          return _vm.onPlayItems(i)
        }
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      staticClass: "course-info",
      on: {
        "click": function($event) {
          return _vm.onPlayItems(i)
        }
      }
    }, [_vm._v(_vm._s(item.views_count) + "人播放")])])
  }), 1), _vm._v(" "), (_vm.row.items.length == 0) ? _c('div', [_c('van-empty', {
    attrs: {
      "description": "暂时还没上传视频!"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.paly_show) ? _c('div', {
    staticClass: "savebtn"
  }, [(!_vm.is_daka) ? _c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.daka
    }
  }, [_vm._v("我要打卡")]) : _c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "size": "normal",
      "native-type": "button",
      "round": ""
    }
  }, [_vm._v("我已打卡\n        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.row.need_pay == '2') ? _c('div', {
    staticClass: "course-bottom"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center",
      "padding": "0 10px",
      "height": "62px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('span', {
    staticClass: "bottom-course"
  }, [_vm._v("课程")]), _vm._v(" "), _c('span', {
    staticClass: "bottom-course-price"
  }, [_vm._v("¥" + _vm._s(_vm.row.price))])]), _vm._v(" "), _c('div', {
    staticClass: "course-pay",
    on: {
      "click": _vm.onPlayShwo
    }
  }, [_vm._v("立即购买")])])]) : _vm._e(), _vm._v(" "), _c('van-overlay', {
    attrs: {
      "show": _vm.pay_show
    },
    on: {
      "click": function($event) {
        _vm.pay_show = false
      }
    }
  }, [_c('div', {
    staticClass: "wrapper",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticStyle: {
      "flex": "1",
      "display": "flex",
      "justify-content": "center",
      "flex-direction": "column"
    }
  }, [_c('p', [_vm._v("本视频需要付费开通")]), _vm._v(" "), _c('p', [_vm._v("您可以选择在线支付或者使用激活卡")])]), _vm._v(" "), _c('div', {
    staticClass: "pay-show-bottom"
  }, [_c('span', {
    staticClass: "no-pay",
    on: {
      "click": function($event) {
        _vm.pay_show = false
      }
    }
  }, [_vm._v("不看了")]), _vm._v(" "), _c('span', {
    staticClass: "on-pay",
    on: {
      "click": _vm.onPlayShwo
    }
  }, [_vm._v("立即开通")])])])])]), _vm._v(" "), (_vm.showWxShare) ? _c('div', {
    staticClass: "shareShow",
    on: {
      "click": _vm.onShareCancel
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('van-popup', {
    style: ({
      height: '30%'
    }),
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.show_share_panel),
      callback: function($$v) {
        _vm.show_share_panel = $$v
      },
      expression: "show_share_panel"
    }
  }, [_c('div', {
    staticClass: "share-panel"
  }, [_c('div', {
    staticClass: "share-title"
  }, [_vm._v("请选择分享方式")]), _vm._v(" "), _c('div', {
    staticClass: "share-ul"
  }, [_c('div', {
    staticClass: "share-weixin",
    on: {
      "click": _vm.shareWeixinFriend
    }
  }, [_c('p', [_vm._v("微信好友")])]), _vm._v(" "), _c('div', {
    staticClass: "share-timeline",
    on: {
      "click": _vm.shareWeixinTimeLine
    }
  }, [_c('p', [_vm._v("朋友圈")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.copy_text),
      expression: "copy_text",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (function() {
        _vm.copySuccess();
        _vm.show_share_panel = false
      }),
      expression: "function(){copySuccess();show_share_panel=false }",
      arg: "success"
    }],
    staticClass: "share-copy"
  }, [_c('p', [_vm._v("复制链接")])])])])]), _vm._v(" "), _c('NavFloatShare', {
    on: {
      "show": function($event) {
        _vm.show_share_panel = true
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("点击分享给好友")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e011970","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/course/CourseDetail.vue
// module id = 2514
// module chunks = 0